import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { logout } from "../slices/authSlice";
import {
  forceSessionLogout,
  getApiErrorMessage,
  isPublicRoute,
  isSessionExpiredError,
} from "../../utils/authSession";

const baseQuery = fetchBaseQuery({
  baseUrl: "https://nodebackend.mapsims.store/api/v1",
  credentials: "include",
});

export const baseQueryWithAuthHandling = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  if (!result.error) {
    return result;
  }

  const url = typeof args === "string" ? args : args?.url || "";
  const status = result.error.status ?? result.error.originalStatus;
  const message = getApiErrorMessage(result.error);

  if (!isPublicRoute() && isSessionExpiredError(status, message, url)) {
    api.dispatch(logout());
    forceSessionLogout(message || "Session expired. Please sign in again.");
  }

  return result;
};
